var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStatisticheIndividuali(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M559.01,0h-94.04c-51.69.6-93.44,42.35-94.04,94.04v854.2c0,41.84,33.91,75.76,75.76,75.76h127.13c41.84,0,75.76-33.91,75.76-75.76V94.04c0-24.38-10.45-48.77-27.87-66.17-17.42-17.4-34.82-27.87-62.69-27.87h0ZM931.7,278.64h-94.04c-51.69.6-93.44,42.35-94.04,94.04v575.56c0,41.84,33.91,75.76,75.76,75.76h127.13c41.84,0,75.76-33.91,75.76-75.76V372.69c0-24.38-10.45-48.77-27.87-66.17-13.93-17.42-38.32-27.87-62.69-27.87h0ZM205.33,1024h-127.84c-41.84,0-75.76-33.91-75.76-75.76v-296.93c.6-51.69,42.35-93.44,94.04-94.04h94.04c51.69.6,93.44,42.35,94.04,94.04l-2.78,297.63c-.39,41.57-34.19,75.05-75.76,75.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatisticheIndividuali);
export default __webpack_public_path__ + "static/media/menu-statistiche-individuali.d94071333eee81cb4dc2a9030f2f8804.svg";
export { ForwardRef as ReactComponent };